import React from "react";
import LearnMore from "./learnMore";

export default function KBLearnMore({ title, kbTitle, description, kbUrl, ...rest }) {
  return (
    <LearnMore
      title={title}
      {...rest}
      content={
        <p>
          {description} Read more in the {kbTitle || title} KB:{" "}
          <a className="kb-learn-more__link" href={kbUrl} target="_blank" rel="noopener noreferrer">
            link
          </a>
          .
        </p>
      }
    />
  );
}
